import React from "react";
import capitalize from "lodash/capitalize";
import { bulkEditSales } from "src/apiService/modules/sales";
import { useRecordEvent } from "src/hooks/useRecordEvent";

import CommonBulkEditDialog, {
  BulkEditDialogText,
  BulkEditDialogTextList,
  BulkEditDialogTextListItem,
} from "src/components/BulkEditDialog";

interface BulkEditDialogProps {
  open: boolean;
  onClose: () => void;
  entity?: string;
}

function BulkEditDialog({
  open,
  onClose,
  entity = "sales",
}: BulkEditDialogProps) {
  const recordEvent = useRecordEvent();

  return (
    <CommonBulkEditDialog
      open={open}
      onClose={onClose}
      bulkEdit={(rows, metadata) => {
        recordEvent({
          type: "feature-adoption",
          feature: "bulk-edit",
          element: entity === "sales" ? "sales" : "refunds",
        });
        return bulkEditSales(rows, metadata);
      }}
      title={`Bulk Edit ${capitalize(entity)}`}
      label={`Click to Upload ${capitalize(entity)} File`}
    >
      <BulkEditDialogText>
        {`You can bulk edit ${entity} in My Reseller Genie by following these steps:`}
      </BulkEditDialogText>
      <BulkEditDialogTextList>
        <BulkEditDialogTextListItem>
          {`Filter for the ${entity} you want to edit`}
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Download the data by clicking the “Export” button on the table.
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Open the file and edit any fields that you’d like to change.
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Save the file and upload below.
        </BulkEditDialogTextListItem>
      </BulkEditDialogTextList>
    </CommonBulkEditDialog>
  );
}

export default BulkEditDialog;
